import React from 'react'
import { OrderState } from 'goustouicomponents/dist'
import {
  Box,
  Text,
  FontWeight,
  JustifyContent,
} from '@gousto-internal/citrus-react'
import { RecipesImagery } from '../RecipesImagery'

type OrderDetailsProps = {
  deliveryDate: string,
  price: string,
  orderState: string,
  recipeImages: { alt: string, src: string }[]
}

const OrderDetails = ({
  deliveryDate,
  orderState,
  price,
  recipeImages,
}: OrderDetailsProps) => {
  const formattedPrice = new Intl.NumberFormat(
    'en-GB',
    { style: 'currency', currency: 'GBP', maximumFractionDigits: 2 },
  ).format(Number(price))

  return (
    <>
      <Box display="flex" justifyContent={JustifyContent.SpaceBetween}>
        <Text fontWeight={FontWeight.SemiBold}>{deliveryDate}</Text>
        {price && <Text data-testing="price" fontWeight={FontWeight.SemiBold}>{formattedPrice}</Text>}
      </Box>
      {orderState && (
        <Box paddingBottom={3}>
          <OrderState state={orderState} />
        </Box>
      )}
      <Box paddingBottom={3}>
        <RecipesImagery items={recipeImages} />
      </Box>
    </>
  )
}

export { OrderDetails }
